
    import { Component, Prop } from 'vue-property-decorator';
    import { Notification, PackageKS2Review } from '@/api/model/interfaces';
    import * as Odata from '@/api/odata';
    import NotificationItem from '@/components/common/notification-item.vue';

    @Component
    export default class Ks2ReviewNew extends NotificationItem {
        @Prop({ required: true })
        notification!: Notification;

        review: PackageKS2Review | null = null;

        async mounted() {
            this.review = await Odata.PackageKS2Review.setParams({
                expand: [ 'Reviewer($expand=ReviewedEntity)' ],
            }).getById(this.notification.EntityId.toString());
            this.link = this.review.Reviewer?.ReviewedEntity
                ? `/ks2/packages/${this.review.Reviewer.ReviewedEntity.Id}`
                : null;
        }
    }
